import { render, staticRenderFns } from "./shareSet.vue?vue&type=template&id=67f1f195&scoped=true&"
import script from "./shareSet.vue?vue&type=script&lang=js&"
export * from "./shareSet.vue?vue&type=script&lang=js&"
import style0 from "./shareSet.vue?vue&type=style&index=0&id=67f1f195&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1f195",
  null
  
)

export default component.exports